





















































import { reactive, watch } from '@vue/composition-api';
import { BAlert, BImg } from 'bootstrap-vue';
import LoginPassword from '../components/LoginPassword.vue';
import LoginSignupButtons from '../components/LoginSignupButtons.vue';
import LoginGoogle from '../components/LoginGoogle.vue';
import LoginFacebook from '../components/LoginFacebook.vue';
import LoginMetamask from '../components/LoginMetamask.vue';
import LoginDotwallet from '../components/LoginDotwallet.vue';
import store from '../store';
export default {
  name: 'Login',
  components: {
    LoginPassword,
    LoginSignupButtons,
    BAlert,
    BImg,
    LoginGoogle,
    LoginFacebook,
    LoginMetamask,
    LoginDotwallet,
  },
  setup() {
    const state = reactive({
      landing: true as boolean,
      email: '' as string,
      password: '' as string,
      emailValidation: false as boolean,
      passwordValidation: false as boolean,

      apiErrorMsg: '' as string,
      failedLogin: false as boolean,
      dismissSecs: 5 as number,
      dismissCountDown: 0 as number,

      makingRequest: false as boolean,

      showSignup: false as boolean,
    });

    async function showAlert() {
      state.dismissCountDown = state.dismissSecs;
    }
    watch(
      () => state.failedLogin,
      newValue => {
        if (newValue === true) {
          showAlert();
        }
      }
    );
    const loginOrSignup = async function(signup: boolean) {
      state.makingRequest = true;
      state.failedLogin = false;
      const response = await store.dispatch.authMod.passwordAuth({
        password: state.password,
        username: state.email,
        signup,
      });
      if (response !== 'success') {
        state.makingRequest = false;
        state.failedLogin = true;
        state.apiErrorMsg = response;
      }
    };
    async function countDownChanged(dismissCountDown: number) {
      state.dismissCountDown = dismissCountDown;
    }

    return {
      state,
      loginOrSignup,
      countDownChanged,
    };
  },
};
